var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.21917 10.3753C6.56418 9.94404 7.19347 9.87412 7.62473 10.2191L12 13.7194L16.3753 10.2191C16.8066 9.87412 17.4359 9.94404 17.7809 10.3753C18.1259 10.8066 18.056 11.4359 17.6247 11.7809L13.2494 15.2811C12.519 15.8655 11.4811 15.8655 10.7506 15.2811L6.37534 11.7809C5.94408 11.4359 5.87416 10.8066 6.21917 10.3753Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.926 3.41714C12.7266 2.75817 11.2734 2.75817 10.074 3.41714L4.07399 6.71343C2.79486 7.41616 2 8.75977 2 10.2192V17C2 19.2091 3.79086 21 6 21H18C20.2091 21 22 19.2091 22 17V10.2192C22 8.75976 21.2051 7.41616 19.926 6.71343L13.926 3.41714ZM11.037 5.17002C11.6367 4.84054 12.3633 4.84054 12.963 5.17002L18.963 8.46632C19.6026 8.81768 20 9.48949 20 10.2192V17C20 18.1046 19.1046 19 18 19H6C4.89543 19 4 18.1046 4 17V10.2192C4 9.48949 4.39743 8.81768 5.03699 8.46632L11.037 5.17002Z",
    fill: "#000000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message-icon.16c6dd0ac7926089ea422f9be2be98c1.svg";
export { ForwardRef as ReactComponent };